"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Channel;
(function (Channel) {
    Channel["FACEBOOK"] = "facebook";
    Channel["GOOGLE"] = "google";
    Channel["PCW"] = "pcw";
    Channel["APP"] = "app";
    Channel["OPEN"] = "open";
    Channel["MIJN"] = "mijn";
    Channel["COCKPIT"] = "cockpit";
    Channel["EXTERNAL_PARTNER"] = "external_partner";
    Channel["DAISYCON"] = "daisycon";
})(Channel || (Channel = {}));
exports.default = Channel;
